export const AssetSourceTypeEnum = {
  Vehicle: "vehicle",
  Equipment: "equipment",
  Tyre: "tyre",
};

export const assetTypeOptions = [
  { label: "Vehicle", value: AssetSourceTypeEnum.Vehicle },
  { label: "Equipment", value: AssetSourceTypeEnum.Equipment },
  { label: "Tyre", value: AssetSourceTypeEnum.Tyre },
];

export const getPayloadId = (value) => {
  if (value === "" || value === null || value === undefined) {
    return value;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : value;
};

export const getNormalizedNumericValue = (value) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

const getFirstDefinedValue = (candidates, fallback = "") => {
  for (const candidate of candidates) {
    if (candidate === "" || candidate === null || candidate === undefined) {
      continue;
    }

    return candidate;
  }

  return fallback;
};

export const extractAssetMeterValue = (detailData) =>
  getFirstDefinedValue([
    detailData?.odm,
    detailData?.odo_meter,
    detailData?.usage_meter_reading,
    detailData?.usageMeterReading,
    detailData?.meter_reading,
    detailData?.distance,
    detailData?.distance_covered,
    detailData?.distanceCovered,
    detailData?.total_km_run,
    detailData?.totalKmRun,
    detailData?.covered_distance,
    detailData?.vehicle?.odm,
    detailData?.vehicle?.odo_meter,
    detailData?.last_service?.odo_meter,
  ]);

export const extractLastRecordedMeterValue = (detailData) =>
  getFirstDefinedValue([
    detailData?.last_service?.odo_meter,
    detailData?.odo_meter,
    detailData?.odm,
    detailData?.usage_meter_reading,
    detailData?.usageMeterReading,
    detailData?.meter_reading,
    detailData?.distance,
    detailData?.distance_covered,
    detailData?.distanceCovered,
    detailData?.total_km_run,
    detailData?.totalKmRun,
    detailData?.covered_distance,
    detailData?.vehicle?.odo_meter,
    detailData?.vehicle?.odm,
  ]);

export const getIssueAssetType = (issue) => {
  const normalizedAssetType = String(issue?.asset_type || "")
    .trim()
    .toLowerCase();

  if (Object.values(AssetSourceTypeEnum).includes(normalizedAssetType)) {
    return normalizedAssetType;
  }

  if (
    issue?.vehicle ||
    getNormalizedNumericValue(issue?.vehicle_id) !== null ||
    getNormalizedNumericValue(issue?.vehicle?.id) !== null
  ) {
    return AssetSourceTypeEnum.Vehicle;
  }

  if (
    issue?.equipment ||
    getNormalizedNumericValue(issue?.equipment_id) !== null ||
    getNormalizedNumericValue(issue?.equipment?.id) !== null
  ) {
    return AssetSourceTypeEnum.Equipment;
  }

  if (
    issue?.tyre ||
    getNormalizedNumericValue(issue?.tyre_id) !== null ||
    getNormalizedNumericValue(issue?.tyre?.id) !== null
  ) {
    return AssetSourceTypeEnum.Tyre;
  }

  return "";
};

export const getIssueAssetId = (issue) =>
  getFirstDefinedValue([
    issue?.asset_id,
    issue?.vehicle_id,
    issue?.equipment_id,
    issue?.tyre_id,
    issue?.vehicle?.id,
    issue?.vehicle?.vehicle_id,
    issue?.equipment?.id,
    issue?.equipment?.equipment_id,
    issue?.tyre?.id,
    issue?.tyre?.tyre_id,
    issue?.tyre?.system_id,
  ]);

export const getIssueAssetLabel = (issue, assetType) => {
  if (assetType === AssetSourceTypeEnum.Vehicle) {
    return (
      issue?.vehicle?.registration_number ||
      issue?.vehicle?.registration_no ||
      issue?.vehicle?.vehicle_number ||
      issue?.vehicle?.asset_id ||
      issue?.asset_id ||
      ""
    );
  }

  if (assetType === AssetSourceTypeEnum.Equipment) {
    return (
      issue?.equipment?.equipment_id ||
      issue?.equipment?.title ||
      issue?.equipment?.name ||
      issue?.equipment?.serial_number ||
      issue?.asset_id ||
      ""
    );
  }

  if (assetType === AssetSourceTypeEnum.Tyre) {
    return (
      issue?.tyre?.tyres_id ||
      issue?.tyre?.tyre_id ||
      issue?.tyre?.serial_number ||
      issue?.tyre?.system_id ||
      issue?.asset_id ||
      ""
    );
  }

  return "";
};
